/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { TokenManager } from "./TokenManager";
export type { TAuthContext } from "./TokenManager";
export { TokenStore } from "./TokenStore";
export type { TStoredToken } from "./TokenStore";
export type { ITokenRefreshStrategy } from "./ITokenRefreshStrategy";
export { DomainTokenRefreshStrategy } from "./DomainTokenRefreshStrategy";
export {
  AuthRejectionArbiter,
  SecureProbeVerdict
} from "./AuthRejectionArbiter";
export type { TSecureProbe } from "./AuthRejectionArbiter";
export type { IProvisioningStrategy } from "./IProvisioningStrategy";
export { DeviceProvisioningStrategy } from "./DeviceProvisioningStrategy";
export type {
  TIdentityRemovalHandler,
  TPersistProvisionData
} from "./DeviceProvisioningStrategy";
export { getTokenGeneration } from "./tokenGeneration";
export { ACCOUNT_CONTEXT_ID, TOKEN_EXPIRY_SKEW_MS } from "./tokenConstants";
export type { TAuthorizationSchemes } from "./authSchemes";
export {
  DEFAULT_AUTH_SCHEMES,
  findAuthorizationSchemes,
  findIpAutoLoginAuthenticationUrl,
  resolveAuthorizationSchemes,
  resolveDbsSchemes,
  resolveDomainTokenScheme,
  resolveIpAutoLoginAuthenticationUrl
} from "./authSchemes";
